import { apiClient } from '@/utils/apiClient'
import type { CreateSupportTicketRequest, SupportTicket } from '@arrowise/shared'

export const supportService = {
    submitTicket: async (payload: CreateSupportTicketRequest): Promise<SupportTicket> => {
        const resp = await apiClient.post<{ ticket: SupportTicket }>('/support', payload)

        if (!resp || !resp.success) {
            throw new Error(resp?.message || 'Failed to create support ticket')
        }

        const ticket = resp.data?.ticket
        if (!ticket) throw new Error('Missing ticket in response')
        return ticket
    },
    submitSessionBuildFailureTicket: async (sessionId: string, userId: string | null, teamId: string | null): Promise<SupportTicket> => {
        const payload: CreateSupportTicketRequest & { requesterUuid?: string | null } = {
            subject: 'BUILD_FAILURE',
            description: `Session build failed for session ${sessionId}`,
            requesterEmail: null,
            priority: 'high',
            teamUuid: teamId || null,
            requesterUuid: userId || null,
            attachments: null,
            metadata: {
                sessionId,
                url: typeof window !== 'undefined' ? window.location.href : null,
                userAgent: typeof navigator !== 'undefined' ? navigator.userAgent : null,
            },
        }

        const resp = await apiClient.post<{ ticket: SupportTicket }>('/support', payload)
        if (!resp || !resp.success) {
            throw new Error(resp?.message || 'Failed to create support ticket')
        }

        const ticket = resp.data?.ticket
        if (!ticket) throw new Error('Missing ticket in response')
        return ticket
    },
}

export default supportService
